import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showErrorToast = (message) => {
  //const message = getErrorMessage(error);
  toast.error(message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const getErrorMessage = (error) => {
  if (!error) return "An unknown error occurred";
  
  const errorMap = {
    "Request failed with status code 401": "No user with the provided credentials was found. Please check email and password again",
    "Network Error": "Seems like you are not connected to the internet",
    "Request failed with status code 500": "An error occurred. Please try again later",
    "Request failed with status code 400": "Invalid Email Address",
  };

  if (error.response?.data?.detail) {
    return error.response.data.detail;
  }

  return errorMap[error.message] || error.message;
};
